<template>
  <div class="courseDetailBox">
    <div
      class="content"
      id="content"
      ref="content"
    >
      <mescroll-vue
        ref="mescroll"
        :down="mescrollDown"
        :up="mescrollUp"
        @init="mescrollInit"
        class="allmescroll"
      >
        <div class="cover">
          <img
            :src="info.image"
            alt=""
          />
          <span
            class="share"
            v-if="info.commissions > 0"
          ><i></i><em>分享赚{{ info.commissions }}</em></span>
        </div>
        <div
          class="courseContent"
          ref="courseContent"
        >
          <CourseTop
            :courseType="courseType"
            :info="info"
            :dataInfo="dataInfo"
            :systemtime="systemtime"
            v-on:courseTopCallback="courseTopCallback"
          ></CourseTop>
          <div
            class="nav"
            ref="nav"
          >
            <span
              :class="navIndex == index ? 'active' : ''"
              v-for="(item, index) in navList"
              :key="index"
              @click="switckNav(index)"
            >{{ item.name }}</span>
          </div>
          <div
            class="nav ceilingNav"
            v-if="ceiling"
          >
            <span
              :class="navIndex == index ? 'active' : ''"
              v-for="(item, index) in navList"
              :key="index"
              @click="switckNav(index)"
            >{{ item.name }}</span>
          </div>
          <div class="courseCatalog">
            <swiper
              ref="mySwiper"
              :options="swiperOption"
              class="swiper-wrapper"
            >
              <swiper-slide>
                <Introduction
                  v-if="showNav.indexOf(0) != -1 && info"
                  :info="info"
                  :courseType="courseType"
                  v-on:evaluationCallback="evaluationCallback"
                ></Introduction>
              </swiper-slide>
              <swiper-slide>
                <Directory
                  v-if="showNav.indexOf(1) != -1 && info"
                  :info="info"
                  v-on:directoryCallback="directoryCallback"
                  :courseType="courseType"
                ></Directory>
              </swiper-slide>
              <swiper-slide>
                <Evaluation
                  v-if="showNav.indexOf(2) != -1 && info"
                  :systemtime="systemtime"
                  :courseType="courseType"
                  v-on:evaluationCallback="evaluationCallback"
                  :evaluationList="evaluationList"
                  :evaluationScoreList="evaluationScoreList"
                  :evaluationStar="evaluationStar"
                  :evaluationTotal="evaluationTotal"
                  :replaySuccessData="replaySuccessData"
                ></Evaluation>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </mescroll-vue>
    </div>
    <div
      class="opationBox clearfix"
      v-if="info"
    >
      <CourseFooter
        :courseType="courseType"
        :info="info"
        :dataInfo="dataInfo"
        :systemtime="systemtime"
        :posterskuId="posterskuId"
        v-on:courseFooterCallback="courseFooterCallback"
      ></CourseFooter>
    </div>
    <div
      class="newToastBox"
      v-if="showToast"
    >
      <div
        class="bg"
        @click="(showToast = false), (replayText = '')"
      ></div>
      <div class="content clearfix">
        <div class="left">
          <input
            type="text"
            v-model="replayText"
            :placeholder="'回复' + replayData.nickname"
          />
        </div>
        <div class="right">
          <span @click="replay()">发送</span>
        </div>
      </div>
    </div>
    <Toast
      :toastData="toast"
      :show="showToast1"
      v-on:toastCallBack="toastCallBack"
    ></Toast>
  </div>
</template>
<script>
import Introduction from "./components/courseIntroduction";
import Evaluation from "./components/courseEvaluation";
import Directory from "./components/courseDirectory";
import MescrollVue from "mescroll.js/mescroll.vue";
import CourseTop from "./components/courseTop";
import CourseFooter from "./components/courseFooter";
import Toast from "@/components/toast.vue";

export default {
  name: "courseDetail",
  props: ["packageId"],
  metaInfo() {
    return {
      title: "课程详情",
    };
  },
  data() {
    return {
      collection: "N",
      ceiling: false,
      navList: [{ name: "简介" }, { name: "目录" }, { name: "评价" }],
      navIndex: 0,
      showNav: [0],
      info: "", //course数据
      dataInfo: "", //全部数据
      sellingprice: "",
      systemtime: "",
      startdate: "", //活动开始时间
      enddate: "", //活动结束时间
      countDown: "", //倒计时

      courseId: "",
      courseType: "", //coursetype  1000 普通课程  1001 秒杀  1002 团购  1003 套餐
      showBuy: false,
      playLessionid: "",

      swiperOption: {
        autoHeight: true,
        onSlideChangeEnd: function (swiper) {
          this.switckNav(swiper.activeIndex);
        }.bind(this),
      },

      evaluationList: [],
      evaluationStar: "",
      evaluationTotal: "",
      evaluationScoreList: "",

      scrollTop: "",
      mescroll: null, // mescroll实例对象
      mescrollDown: {
        use: false,
        callback: this.downCallback,
      },
      mescrollUp: {
        onScroll: this.scroll,
        callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
        //以下是一些常用的配置,当然不写也可以的.
        page: {
          num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 10, //每页数据条数,默认10
        },
        htmlNodata: '<p class="upwarp-nodata">没有更多了~</p>',
        noMoreSize: 10, //如果列表已无数据,可设置列表总数大于5才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        empty: {
          //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
          // warpId: "xxid", //父布局的id (1.3.5版本支持传入dom元素)
          //icon: "./static/mescroll/mescroll-empty.png", //图标,默认null,支持网络图
          tip: "暂无相关数据~", //提示
        },
      },
      showToast: false,
      replayText: "",
      replayData: "",
      replaySuccessData: "",

      freeObj: "",
      posterskuId: "",  //免费订单相关id
      showToast1: false,
      toast: "",
    };
  },
  components: {
    Introduction,
    Evaluation,
    Directory,
    MescrollVue,
    CourseTop,
    CourseFooter,
    Toast,
  },
  beforeRouteEnter(to, from, next) {
    next((_this) => {
      if (_this.$store.state.state.keepAlive.indexOf("courseDetail") != -1) {
        setTimeout(() => {
          _this.mescroll && _this.mescroll.scrollTo(_this.scrollTop);
        }, 0);
      }
    });
  },
  mounted() {
    this.courseId = this.packageId ? this.packageId : this.$route.query.courseId;
    this.courseType = this.packageId ? 1003 : this.$route.query.courseType;
    this.posterskuId = this.$route.query.posterskuId ? this.$route.query.posterskuId : "";
    this.getInfo();
  },
  beforeDestroy() {
    clearInterval(this.countDown);
  },
  watch: {},
  methods: {
    scroll(data) {
      var scrollY = data.preScrollY;
      this.scrollTop = data.preScrollY;
      if (this.navTop > 0) {
        this.ceiling = scrollY > this.navTop;
      }
    },
    evaluationCallback(data) {
      var _this = this;
      if (data.type == "replay") {
        if (this.util.loginStatus()) {
          this.replayData = data.data;
          this.showToast = true;
        } else {
          this.util.loginAgain();
        }
      } else if (data.type == "reload") {
        setTimeout(function () {
          _this.$refs.mySwiper.swiper.update();
        }, 50);
      }
    },
    directoryCallback(data) {
      var _this = this;
      if (data.type == "showBuy") {
        this.showBuy = data.showBuy;
      } else if (data.type == "reload") {
        setTimeout(function () {
          _this.$refs.mySwiper.swiper.update();
        }, 50);
      } else if (data.type == "play") {
        if (this.navIndex != 1) {
          this.switckNav(1);
        }
        console.log(data);
        //this.playInfo = data.playInfo;
      }
    },
    courseFooterCallback(data) {
      if (data.type == "reload") {
        this.getInfo();
      }
    },
    courseTopCallback(data) {
      if (data.type == "receive") {
        this.showToast1 = true;
        this.toast = {
          title: "优惠",
          btnText: "",
          type: "receive",
          background: "#fff",
          list: data.list,
          businessid: this.courseType == 1003 ? this.info.packageid : this.info.courseid,
          businesstype: this.info.coursetype,
        };
      }
    },
    toastCallBack(e) {
      var type = e.type;
      var data = e.data;
      switch (type) {
        case "close":
          break;
        case "submit":
          if (data) {
            if (data.type == "discount") {
            }
          }
          break;
        default:
          break;
      }
      this.showToast1 = false;
    },
    getInfo() {
      var courseType = this.courseType;
      var _this = this;
      var url = "",
        obj = {};
      switch (courseType - 0) {
        case 1000:
        case 1005:
          url = "iart-api-scm/api/scm/course/queryByCourse";
          obj = { courseId: this.courseId };
          break;
        case 1003:
          url = "iart-api-scm/api/scm/package/queryCosPackInfo";
          obj = { packageId: this.courseId };
          break;
        case 1002:
          url = "iart-api-crm/api/crm/promotiongroup/queryPromotiongroupsku";
          obj = { promotiongroupdkuid: this.courseId };
          break;
        case 1001:
          url = "iart-api-crm/api/crm/flashsale/queryFlashsalesku";
          obj = { flashsaleskuid: this.courseId };
          break;
        default:
          break;
      }
      this.$post(url, obj).then((res) => {
        if (res.code == 1) {
          var data = this.courseType == 1002 || this.courseType == 1001 ? res.data.course : res.data;
          this.info = data;
          this.dataInfo = res.data;
          this.collection = data.collection;
          this.systemtime = res.systemtime + 1000;
          this.evaluationStar = data.staringcount ? data.staringcount : 0;
          this.evaluationTotal = data.evaluationcount ? data.evaluationcount : 0;
          if (this.courseType == 1003) {
            this.sellingprice = data.packageprices && data.packageprices[0].sellingprice;
          } else {
            this.sellingprice = data.coursepricedtoes && data.coursepricedtoes[0].sellingprice;
          }
          setTimeout(() => {
            _this.navTop = _this.$refs.nav.getBoundingClientRect().top;
          }, 300);
          this.shareLink();
          if (this.util.loginStatus() && this.courseType == 1000) {
            this.playLessionid = res.data.newlessonid;
          }
          //处理拼团以及秒杀的倒计时问题
          if (this.courseType == 1002 || this.courseType == 1001) {
            this.enddate = res.data.enddate;
            this.startdate = res.data.startdate;
            if (res.systemtime > res.data.enddate) {
              this.courseType = 1000;
            } else {
              this.countDown = setInterval(() => {
                _this.systemtime = _this.systemtime + 1000;
                if (_this.systemtime == _this.startdate) {
                  _this.$router.go(0);
                }
                if (_this.systemtime > _this.enddate) {
                  clearInterval(_this.countDown);
                  _this.$router.go(0);
                }
              }, 1000);
              if (res.systemtime < res.data.startdate) {
                //this.courseType = 1000;
              } else {
              }
            }
          }
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    switckNav(index) {
      var _this = this;
      this.navIndex = index;
      this.showNav.indexOf(index) == -1 ? this.showNav.push(index) : "";
      this.$refs.mySwiper.swiper.slideTo(index, 200, false);
      setTimeout(function () {
        _this.$refs.mySwiper.swiper.update();
      }, 300);
    },

    mescrollInit(mescroll) {
      this.mescroll = mescroll;
    },
    upCallback(page, mescroll) {
      this.getListDataFromNet(page.num, page.size, mescroll);
    },
    downCallback() {
      this.mescroll.resetUpScroll();
    },
    getListDataFromNet(num, size, mescroll) {
      if (num === 1) {
        this.evaluationList = [];
      }
      var obj = {
        businesstype: "1000",
        businessid: this.courseId,
        pageNum: num,
        pageSize: size,
      };
      this.$post(
        "iart-api-crm/api/crm/custservice/queryByCustomercommentList",
        obj
      ).then((res) => {
        if (res.code == 1) {
          if (res.data.rtncode == 1) {
            var data = res.data.rows ? res.data.rows : [];
            this.evaluationScoreList = res.data.scoreList.reverse();
            this.evaluationList = this.evaluationList.concat(data);
            this.$nextTick(() => {
              mescroll.endSuccess(data.length);
            });
          } else {
            this.util.toast({
              msg: res.data.rtnmsg,
            });
          }
        } else {
          this.util.toast({
            msg: res.message,
          });
        }
      });
    },
    shareLink() {
      var _this = this;
      var url = _this.$store.state.state.shareUrl;
      if (this.courseType == 1000) {
        url += +"#/h5/course/courseDetail?courseId=" + this.courseId + "&courseType=" + this.courseType;
      } else {
        url += +"#/h5/course/coursePackage?packageId=" + this.packageId;
      }
      let dataInfo = this.dataInfo;
      // courseType: "", //coursetype  1000 普通课程  1001 秒杀  1002 团购  1003 套餐
      if (this.coursetype == 1001 || this.coursetype == 1002) {
        dataInfo = this.dataInfo.course;
      }
      var data = {
        title: dataInfo.sharetitle,
        desc: dataInfo.signature ? dataInfo.signature : "", // 分享描述
        url: url,
        imgUrl: dataInfo.shareicon,
      };
      this.util.shareLink(this, data).then(function () { });
    },
    buy() {
      var info = this.info;
      if (!this.util.loginStatus()) {
        this.util.wechatLogin();
        return false;
      }
      if (info.customercourse == "Y") {
        var obj = {};
        obj.lessonid = this.playLessionid
          ? this.playLessionid
          : info.chapters[0].lessons[0].lessonid;
      } else {
        if (this.sellingprice > 0) {
          this.$router.push({
            path: "/common/order",
            query: {
              ordertype: this.courseType,
              productid:
                this.courseType == 1000
                  ? this.info.coursepricedtoes[0].productid
                  : this.info.packageprices[0].productid,
            },
          });
        } else {
          this.freeObj = {
            ordertype: this.courseType,
            buyNum: 1,
            productid:
              this.courseType == 1000
                ? this.info.coursepricedtoes[0].productid
                : this.info.packageprices[0].productid,
          };
        }
      }
    },
    replay() {
      if (this.replayText.trim().length > 0) {
        var obj = {
          commenid: this.replayData.commentid,
          replystatus: 2000,
          content: this.replayText.trim(),
        };
        this.$post(
          "iart-api-crm/api/crm/custservice/createByCustomercommentReply",
          obj
        ).then((res) => {
          if (this.util.processingData(res)) {
            if (res.code == 1) {
              if (res.data.rtncode == 1) {
                var data = res.data;
                this.showToast = false;
                this.replayText = "";
                data.replayIndex = this.replayData.replayIndex;
                this.replaySuccessData = data;
              } else {
                this.util.toast({ msg: res.data.rtnmsg });
              }
            } else {
              this.util.toast({ msg: res.message });
            }
          }
        });
      } else {
        this.util.toast({ msg: "请输入回复内容" });
      }
    },
    goto(loginStatus, url, data) {
      if (loginStatus) {
        if (this.util.loginStatus()) {
          return false;
        }
        this.$router.push({
          path: url,
          query: data ? data : {},
        });
      }
      this.$router.push({
        path: url,
        query: data ? data : {},
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.courseDetailBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  min-height: 100%;
  background: #fff;
  flex-direction: column;
  display: flex;
  .content {
    flex: 1;
    overflow: auto;
    position: relative;
    z-index: 12;
    .cover {
      position: relative;
      .share {
        position: absolute;
        top: 14px;
        right: 16px;
        background: #fff;
        border-radius: 3px;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
        padding: 8px;
        perspective: 1000;
        i {
          display: inline-block;
          width: 12px;
          height: 15px;
          background: url(../../../assets/img/h5/course_share.png) no-repeat;
          background-size: 12px 15px;
          vertical-align: middle;
        }
        em {
          font-size: 12px;
          line-height: 17px;
          color: rgba(53, 54, 60, 1);
          font-weight: 500;
          margin-left: 7px;
          vertical-align: middle;
        }
      }
      .share::before {
        content: " ";
        display: inline-block;
        border: 8px solid transparent;
        width: 8px;
        height: 8px;
        border-bottom-color: #fff;
        // background: red;
        position: absolute;
        top: -14px;
        right: 10px;
        z-index: 10;
        transform: rotateY(45deg);
      }
    }
    .courseContent {
      position: relative;
      z-index: 10;
      height: 100%;
      display: flex;
      flex-direction: column;
      margin-top: -70px;
      .nav {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        border-bottom: 0.5px solid rgba(151, 151, 151, 0.2);
        span {
          font-size: 14px;
          line-height: 24px;
          color: rgba(134, 135, 138, 1);
          padding: 10px 0;
          font-weight: bolder;
        }
        span.active {
          color: rgba(53, 54, 60, 1);
          position: relative;
        }
        span.active::before {
          content: " ";
          display: inline-block;
          position: absolute;
          left: 50%;
          margin-left: -9px;
          bottom: 0;
          width: 18px;
          height: 2px;
          background: rgba(53, 54, 60, 1);
        }
      }
      .ceilingNav {
        position: fixed;
        left: 0;
        right: 0;
        background: #fff;
        z-index: 99;
        top: 0;
      }
      .courseCatalog {
        flex: 1;
        overflow: auto;
      }
    }
  }
  .opationBox {
    display: flex;
    flex-direction: row;
    align-items: center;
    background: #fff;
    box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 10;
    .left {
      background: #fff;
      padding: 0 32px;
      > div {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        i {
          display: inline-block;
          width: 24px;
          height: 24px;
        }
        span {
          font-size: 11px;
          line-height: 16px;
          color: #666666;
          margin-top: 2px;
        }
      }
      > div:not(:last-child) {
        margin-right: 32px;
      }
      .collection i {
        background: url(../../../assets/img/h5/collection.png) no-repeat;
        background-size: 24px 24px;
      }
      .collection .collections {
        background: url(../../../assets/img/h5/collections.png) no-repeat;
        background-size: 24px 24px;
      }
      .server i {
        background: url(../../../assets/img/h5/server.png) no-repeat;
        background-size: 24px 24px;
      }
    }
    .group {
      flex: 1;
      font-size: 16px;
      line-height: 22px;
      color: #333333;
      text-align: center;
      padding: 0;
    }
    .right {
      flex: 1;
      background: #db1a1f;
      text-align: center;
      span {
        display: inline-block;
        font-size: 16px;
        color: #ffffff;
        line-height: 49px;
        height: 49px;
      }
    }
  }
  .newToastBox {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 11;
    .bg {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 10;
      background: rgba(0, 0, 0, 0.4);
    }
    .content {
      display: flex;
      flex-direction: row;
      align-items: center;
      background: #fff;
      padding: 16px;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 11;
      .left {
        flex: 1;
        border-radius: 20px;
        background: #f7f7f7;
        padding: 10px 20px;
        input {
          width: 100%;
          color: #333;
          font-size: 14px;
          line-height: 20px;
        }
        input::placeholder {
          color: #cccccc;
          font-size: 14px;
          line-height: 20px;
        }
      }
      .right {
        margin-left: 16px;
        span {
          font-size: 16px;
          line-height: 22px;
          color: #db1a1f;
        }
      }
    }
  }
}
</style>